module.exports = __webpack_public_path__ + "static/media/add.604f24ad.svg";